<template>
  <loading-icon class="c-card" v-if="loading"></loading-icon>
  <section class="c-card" v-else>

    <div class="c-card__header">
      <h2 class="c-card__title t-headline" v-if="card.title">{{ card.title }}</h2>
    </div>

    <div class="c-card__body s-html" v-html="card.content">
    </div>

  </section><!--END CARD-->
</template>





<script>
  import $ from 'jquery'
  import { mapGetters } from 'vuex'
  import util from '@/functions'

  export default {
    name: 'ContentCard',
    props: ['card'],
    computed: {
      ...mapGetters([
        'websiteConfig'
      ]),
      loading () {
        return !this.card.cardLoaded
      }
    },
    mounted () {
      $(this.$el).find('div.c-card__body a').off('click')
      $(this.$el).find('div.c-card__body a').on('click', this.handleLink)
    },
    updated () {
      $(this.$el).find('div.c-card__body a').off('click')
      $(this.$el).find('div.c-card__body a').on('click', this.handleLink)
    },
    methods: {
      handleLink (e) {
        util.handleLink(e, this.websiteConfig, this.$router)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Content.vue?20e601cf